export const enum Collection {
  FEATURE_PRODUCTS = "features",
  MENU = "menu",
  CAREERS = "careers",
  HOME_DISPLAY = "home",
  MERCHANDISE_PRODUCTS = "merchandise"
}
